<template>

    <div class="row">

      <template v-if="signedIn">
        {{get_signed_in_redirection}}
      </template>
      <template v-else>

        <div class="col-3 signin_box">

          <form class="" v-on:submit="checkForm" method="post">

            <div v-if="errors.length">
              <ul class="validation-error mb-3">
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
            </div>
            <div v-if="globalError">
              <ul class="validation-error mb-3">
                <li>{{ globalError }}</li>
              </ul>
            </div>

            <div class="">
              <label class="signin_label" for="user">Account</label>
              <input
                  type="text"
                  class="signin_input"
                  id="user"
                  v-model="user"
                  placeholder=""
                  name="user"
                  required
              />
            </div>

            <div class="">
              <label class="signin_label" for="password">Password</label>
              <input
                  type="password"
                  class="signin_input"
                  id="password"
                  v-model="password"
                  placeholder=""
                  required
              />
            </div>

            <label class="signin_label" for="user"></label>
            <input class="signin_button" type="submit" value="Signin" />

          </form>
        </div>

      </template>
    </div>

</template>

<script>
    import { signIn } from "../../utils/auth.js";
    import { mapGetters } from "vuex";

    export default {
      data() {
        return {
          errors: [],
          customerid:null,
        }
      },
      components: {

      },
      computed: {
       ...mapGetters({
         signedIn:'auth/signedIn',
         globalError: "getGlobalError"
       }),
       get_signed_in_redirection() {
         this.signed_in_redirection();
         return "";
       },
      },
      mounted() {
        this.customerid =  this.$route.query.customerid;
      },
      methods: {
       checkForm: async function(e) {
         this.errors = [];
         if (!this.user) {
           this.errors.push("User name required.");
         }
         if (!this.password) {
           this.errors.push("Password required.");
         }
         e.preventDefault();
         if (!this.errors.length) {
           signIn(this.user, this.password, this.$store);
         }
       },
       signed_in_redirection () {

         /*
         Problem ONLY on Live server and not on localhost with "page not found" on new tab opening. 7/17/24

        If the redirection shows "Not Found" on server LIVE, then this .htaccess if needed. /sales/ path for this App running on /sales/ directory
        The problem is that some phone browsers block after no http request, so we have to let them go to http and then redirect to https.

        Allow the .htaccess file to redirect index in vuejs
        sudo nano /etc/httpd/conf/httpd.conf
        AllowOverride none -> AllowOverride All
        Search for THIS position comment in the CONF file, AllowOverride shows up more than once!!

          #
          # AllowOverride controls what directives may be placed in .htaccess files.
          # It can be "All", "None", or any combination of the keywords:
          #   Options FileInfo AuthConfig Limit
          #
          AllowOverride All

          #

        https://stackoverflow.com/questions/71989848/page-refresh-returns-404-error-on-deployed-vuejs-vue-router-apllication

        upload .htaccess to /html/

<ifModule mod_rewrite.c>
  RewriteEngine On
  RewriteBase /sales/
  RewriteRule ^index\.html$ - [L]
  RewriteCond %{REQUEST_FILENAME} !-f
  RewriteCond %{REQUEST_FILENAME} !-d
  RewriteRule . /sales/index.html [L]
</ifModule>

          */

         if(this.customerid) {
           this.$store.dispatch('admin/setBannerType120');
           this.$store.dispatch('admin/setDontSignOut');
           this.$router.push({name: "customer_details", 'params':{customer_id: this.customerid} });
         } else {
           this.$router.push({name: "home"});
         }
       },
      }
    }
</script>


<style scoped>

.signin_box {
  border: 1px solid darkgray;
  padding: 20px;
  border-radius: 10px;
  margin-top: 30px;
  margin-left: 30px;
}

.signin_input {
  width:calc(100% - 145px);
  padding: 5px;
  margin: 5px;
}

.signin_label {
  color: black;
  width: 120px;
  padding: 6px;
  text-align: left;
  font-weight: 600;
  margin: 3px;
}

.signin_button {
  color: black;
  width: 120px;
  padding: 6px;
  border-radius: 10px;
  font-weight: 600;
  margin-top: 10px;
}

</style>
